import { useEffect, useState } from 'react';
import { Button, Grid } from '@material-ui/core';
import makeStyles from '../../style';
import StarIcon from '@material-ui/icons/Star';
// import StarBorderRoundedIcon from '@mui/icons-material/StarBorderRounded';
import companyLogo from '../../../../../../assets/img/common/Ellipse 10.png';
import envelopeIcon from '../../../../../../assets/img/common/envelope-Regular.svg';
import mapMarkerIcon from '../../../../../../assets/img/common/map-marker-Regular.svg';
import phoneIcon from '../../../../../../assets/img/common/phone-Regular.svg';
import { PostDataAPI } from '../../../../../../Services/APIService';

// import StarBorderRoundedIcon from '@material-ui/'



const Rule = ({ color }) => (
    <hr
        style={{
            borderColor: color,
        }}
    />
);

function OrganizationalDetails({ organizationId, params, ...props }) {
    const classes = makeStyles();

    const [donorData, setDonorData] = useState([]);

    const loadDonorDetails = () => {
        let obj = {
            donorId: organizationId
        }
        PostDataAPI("fdngrantdonor/get", obj).then((result) => {
            if (result.success && result.data != null) {
                console.log(result.data);
                setDonorData(result.data);
            }
            else {
                setDonorData([]);
            }

        })
    }

    useEffect(() => {
        loadDonorDetails();
    }, [])


    return (
        <>
            <header>
                <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }} justifyContent='flex-end' >
                  
                    <Grid item>
                        <a href='https://www.irs.gov/pub/irs-pdf/f990.pdf' target='_blank' className={classes.changeBtn} >Download Compliance Report</a>
                    </Grid>
                
                </Grid>
            </header>
            <main className={classes.container} style={{ marginTop: "20px" }}>
                <Grid container justifyContent='space-between' spacing={5}>
                    <Grid item lg={8}>
                        <Grid container>
                            <Grid item xs={12} sm={5}>
                                <div className={classes.companyCard}>
                                    <div className={"companyLogo"}>
                                        <img src={donorData.certificateFilePath} alt='company Logo' />
                                    </div>
                                    <h2 style={{
                                        fontSize: '20px',
                                        marginTop: '14px'
                                    }}>
                                        {donorData.donorName}
                                    </h2>
                                    <h3><span style={{
                                        fontWeight: "bold"
                                    }}>EIN:</span> 21221</h3>
                                </div>
                            </Grid>
                            <Grid item xs={12} sm={6} className={classes.rightSide}>
                                <div className={"rating"}>
                                    <StarIcon style={{ fill: "#5BFF0D" }} />
                                    <StarIcon style={{ fill: "#5BFF0D" }} />
                                    <StarIcon style={{ fill: "#5BFF0D" }} />
                                    <div
                                        style={{
                                            fontWeight: "bold",
                                            fontSize: "larger"
                                        }}
                                    >3.5</div>
                                </div>
                                <div className={"frame"}>
                                    <img src={envelopeIcon} />
                                    <span>{donorData.email}</span>
                                </div>
                                <div className={"frame"}>
                                    <img src={phoneIcon} />
                                    <span>{donorData.phone}</span>
                                </div>
                                <div className={"frame"}>
                                    <img src={mapMarkerIcon} />
                                    <span>{donorData.addressLine1}</span>
                                </div>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item lg={4} alignItems='flex-end' justifyContent="flex-end">
                        <h3 style={{
                            textAlign: "end",
                            fontWeight: 700,
                        }}>
                            Total Grant Allocated: $000
                        </h3>
                        <h3 style={{
                            color: "red",
                            textAlign: "end",
                            fontWeight: 700,
                        }}>
                            Waiting For Approval:  $000
                        </h3>
                    </Grid>
                </Grid>
                <br />
                <Rule color={"#FFFFFF"} />
                {/* <h3 style={{
                    fontFamily: "Lato",
                    fontSize: "20px",
                    fontWeight: 700,
                    margin: "10px 0px"
                }}>Organization Information:</h3> */}
               
              
                <h4
                    style={{
                        margin: "10px 0px",
                        fontWeight: 700
                    }}
                >Contact Person:</h4>
                <div>
                    <div className={classes.contactInfo}>
                        <img width="35px" height="35px" src={companyLogo} />
                        <p
                            style={{
                                margin: "10px 0px",
                                fontWeight: 700,
                                fontSize: "18px"
                            }}
                        >{donorData.contactPersonName}</p>
                    </div>
                    <Grid
                        container
                        direction="row"
                        justifyContent="flex-start"
                        alignItems="center"
                    >
                        <Grid item xs={12} md={6} lg={3}>
                            <div className={classes.frame}>
                                <img src={phoneIcon} />
                                <span>{donorData.contactPersonPhone}</span>
                            </div>
                        </Grid>
                        <Grid item xs={12} md={6} lg={4}>
                            <div className={classes.frame}>
                                <img src={envelopeIcon} />
                                <span>{donorData.contactPersonEmail}</span>
                            </div>
                        </Grid>
                    </Grid>

                </div>
            </main >

        </>
    )
}

export default OrganizationalDetails;




